module.exports = __webpack_public_path__ + "img/Vietnam-Flag.de34980d.svg";